import i18next, { type TFunction } from 'i18next';

// The Tower's pure model modules (tower-model, tower-summary, tower-journal,
// tower-transfer-board) compose most of their copy from live counters, and some
// of their helpers have a signature other lanes already consume
// (`runStatusLabel(status)` is read by the transport desk). So instead of
// leaking English literals, they hold i18n KEYS and resolve them through a
// translator.
//
// Every builder a component memoises takes that translator as its last
// argument: the component passes the `t` from `useTranslation('tower')`, whose
// identity changes on `languageChanged` — that is what makes a memoised river or
// console redraw in the new language. `towerT` is the default for callers with
// no React context (tests, event handlers, the frozen-signature helpers above);
// it is bound to the namespace only, never to a language, so it always resolves
// against whatever language the console is showing right now.

export type TowerT = TFunction<'tower'>;

/** Resolves a key of the `tower` namespace against the console's live language. */
export const towerT: TowerT = i18next.getFixedT(null, 'tower');
